import React from 'react';
import { Tooltip, Typography } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { useTheme } from '@mui/material/styles';

interface InfoTooltipProps {
  title: React.ReactNode;
  placement?: 'top' | 'right' | 'bottom' | 'left';
  iconSx?: object;
  maxWidth?: number | string;
  minWidth?: number | string;
}

const InfoTooltip: React.FC<InfoTooltipProps> = ({ title, placement = 'right', iconSx, maxWidth = 400, minWidth = 220 }) => {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';

  return (
    <Tooltip
      title={
        <Typography sx={{ fontSize: 16, lineHeight: 1.5 }}>
          {title}
        </Typography>
      }
      arrow
      placement={placement}
      componentsProps={{
        tooltip: {
          sx: {
            backgroundColor: isDark ? '#f5f5f5' : '#23272f',
            color: isDark ? '#222' : '#fff',
            borderRadius: 8,
            fontSize: 16,
            py: 2.2,
            px: 4,
            boxShadow: 3,
            maxWidth: 1100,
            minWidth,
          },
        },
        arrow: {
          sx: {
            color: isDark ? '#f5f5f5' : '#23272f',
          },
        },
      }}
    >
      <InfoOutlinedIcon color="primary" sx={{ fontSize: 22, cursor: 'pointer', ...iconSx }} />
    </Tooltip>
  );
};

export default InfoTooltip; 